// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"
import ThemeController from "./theme_controller"
import BodyController from "./body_controller"
import ClampController from "./clamp_controller"
import PasswordVisibility from "@stimulus-components/password-visibility"
import TextareaAutogrow from "stimulus-textarea-autogrow"
import AutoSaveController from "./auto_save_controller";
import RequestActionController from "./request_action_controller";
import CharacterCounter from '@stimulus-components/character-counter'
import Notification from '@stimulus-components/notification'
import EditModeController from "./edit_mode_controller";
import DetailController from "./detail_controller";
import BarchartController from "./barchart_controller";
import ToggleVisibilityController from "./toggle_visibility_controller";
import ScrollToTop from "./scroll_to_top_controller"
import ClimbersManagerController from "./climbers_manager_controller";
import SortableController from "./sortable_controller";
import StopPropagationController from "./stop_propagation_controller"
import FormSubmitController from "./form_submit_controller"
import ImagePreviewController from "./image_preview_controller"
import ImageLinkageController from "./image_linkage_controller"
import AvatarUploadController from "./avatar_upload_controller"
import OpenPictureModalController from "./open_picture_modal_controller";
import CreatePictureDialogController from "./create_picture_dialog_controller";
import PictureSlideshowDialogController from "./picture_slideshow_dialog_controller";
import PictureSlideshowTriggerController from "./picture_slideshow_trigger_controller";
import SearchController from "./search_controller";
import UrlParamController from "./url_param_controller";
import DrawerController from "./drawer_controller";
import CoordinatesController from "./coordinates_controller";
import YoutubeEmbedController from "./youtube_embed_controller";
import TabsController from "./tabs_controller";
import YoutubeConsentController from "./youtube_consent_controller";
import MapController from "./map_controller";
import AreaMapController from "./area_map_controller";
import LoginController from "./login_controller";
import CryptoInitController from "./crypto_init_controller";
import CheckAllController from "./check_all_controller";
import PrivateNoteController from "./private_note_controller";

application.register("theme", ThemeController)
application.register("body", BodyController)
application.register("clamp", ClampController)
application.register("password-visibility", PasswordVisibility)
application.register("auto-save", AutoSaveController)
application.register("request", RequestActionController)
application.register("textarea-autogrow", TextareaAutogrow)
application.register('character-counter', CharacterCounter)
application.register('notification', Notification)
application.register('edit-mode', EditModeController)
application.register('detail', DetailController)
application.register('barchart', BarchartController)
application.register('toggle', ToggleVisibilityController)
application.register('scroll-to-top', ScrollToTop)
application.register('climbers-manager', ClimbersManagerController)
application.register('sortable', SortableController)
application.register('stop-propagation', StopPropagationController)
application.register("form-submit", FormSubmitController)
application.register("image-preview", ImagePreviewController)
application.register("open-picture-modal", OpenPictureModalController)
application.register("create-picture-dialog", CreatePictureDialogController)
application.register("picture-slideshow-dialog", PictureSlideshowDialogController)
application.register("picture-slideshow-trigger", PictureSlideshowTriggerController)
application.register("image-linkage", ImageLinkageController)
application.register("avatar-upload", AvatarUploadController)
application.register("search", SearchController)
application.register("url-param", UrlParamController)
application.register("drawer", DrawerController)
application.register("coordinates", CoordinatesController)
application.register("youtube-embed", YoutubeEmbedController)
application.register("tabs", TabsController)
application.register("youtube-consent", YoutubeConsentController)
application.register("map", MapController)
application.register("area-map", AreaMapController)
application.register("login", LoginController)
application.register("crypto-init", CryptoInitController)
application.register("check-all", CheckAllController)
application.register("private-note", PrivateNoteController)
